import { Mark, mergeAttributes } from '@tiptap/core';

import { SemanticColor } from '../../utils';

export interface SemanticHighlightOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    semanticHighlight: {
      setSemanticHighlight: (color: SemanticColor) => ReturnType;
      unsetSemanticHighlight: () => ReturnType;
    };
  }
}

export const SemanticHighlightMark = Mark.create<SemanticHighlightOptions>({
  name: 'semanticHighlight',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      color: {
        default: null,
        parseHTML: element => element.getAttribute('data-semantic-highlight'),
        renderHTML: attributes => {
          if (!attributes.color) {
            return {};
          }
          return { 'data-semantic-highlight': attributes.color };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'mark[data-semantic-highlight]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'mark',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  addCommands() {
    return {
      setSemanticHighlight:
        (color: SemanticColor) =>
        ({ commands }) => {
          return commands.setMark(this.name, { color });
        },
      unsetSemanticHighlight:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name);
        },
    };
  },
});
